module.exports = __webpack_public_path__ + "img/betmode_result.5cd88161.png";